import type {AriaTextFieldOptions} from 'react-aria';
import {useTextField} from 'react-aria';
import React, {useRef} from "react";

interface TextareaProps extends AriaTextFieldOptions<'textarea'> {
    rows?: number;
    minRows?: number;
    resize?: 'none' | 'vertical' | 'horizontal' | 'both';
}

export function Textarea(props: TextareaProps) {

    const {label, isRequired, isDisabled, rows = 3, minRows, resize = 'vertical'} = props;
    const ref = useRef<HTMLTextAreaElement>(null);
    const {
        labelProps,
        inputProps,
        descriptionProps,
        errorMessageProps,
        isInvalid,
        validationErrors
    } = useTextField(props, ref);

    const resizeClass = {
        'none': 'resize-none',
        'vertical': 'resize-y',
        'horizontal': 'resize-x',
        'both': 'resize'
    }[resize];

    return (
        <div>
            {label && (
                <label {...labelProps} className={`field-label ${isDisabled ? 'field-disabled' : ''}`}>
                    {label}
                    {isRequired && <span className={'field-required'}>*</span>}
                </label>
            )}

            <div className={`field-container ${isDisabled ? 'field-disabled' : ''}`}>
                <textarea
                    {...(inputProps as any)}
                    ref={ref}
                    className={`field-input ${resizeClass}`}
                    rows={rows}
                    style={{
                        minHeight: minRows ? `${minRows * 1.5}em` : undefined
                    }}
                />
            </div>

            {props.description && (
                <div {...descriptionProps} className={'mt-2 text-xs'}>
                    {props.description}
                </div>
            )}

            {isInvalid && (
                <div {...errorMessageProps} className={'field-error'}>
                    {validationErrors.join(' ')}
                </div>
            )}
        </div>
    );
}